import React, { useContext, useEffect, useReducer, useState } from "react";
import { setExternalSignIn, setGoHome, setLoader, setLoaderClosed } from "../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { sendAnalytics } from "../../../action/homeAction";
import { withTranslation } from "react-i18next";
import { CMSPath } from "../../../config/constant";
import { connect } from "react-redux";
import { currentWidget, setShowCustomPopup } from "../../../action/action";
import { MyContext } from ".";
import { inAppBrowser } from "../../JS/inAppBrowser";
import moment from "moment";
import { getVredPointsData } from "../../../action/the_know";
import Loader from "../../UI/loader";

const PointsPage = (props) => {

    const { t } = props;
    const [isLoading, setIsLoading]=useState(true);
    const { dispatchCurrentPage, IPossiblePages, dispatchApiData, IApiData , apiData, handleAccessTokenExpired } = useContext(MyContext)
    const [currentWidgetPrevData, setCurrentWidgetPrevData] = useState({});

   

    const getMyPointsData= async ()=>{
        
        dispatchApiData({type:IApiData.POINTS_ENABLE_FETCHING});

        const accessToken= props.externalSignIn.accessToken;


        await getVredPointsData(accessToken)
        .then((res)=>{
            console.log("getVredPointsData response is ", res)
             if(!(res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS" )){
                throw {response:res};
             }

             if(!(res.data.payload)){
                throw {response:res};
             } 

             dispatchApiData({type:IApiData.POINTS_DATA_SUCCESS, payload: res.data.payload})


        })
        .catch(async({response={}})=>{
            console.log("in catch ", response);
            // props.sendTheAnalytics("Virgin Red Points Fetch", false, t("the_know.api_response.points_failed"))
            // props.closeOrderPopUp(true,  response && response.data && response.data.header && response.data.header.status && response.data.header.status.msg  ||  t("the_know.api_response.points_failed"), "", true);
            
            dispatchApiData({type:IApiData.POINTS_DATA_FAILURE, payload: (response && response.data && response.data.header   && response.data.header.status  && response.data.header.status.msg ) || t("the_know.api_response.points_failed") })
            if(response.status==403 || response.status==400  ){
                console.log("session token expired/ incorrect.")
                // show session token expired, so re-login
                await handleAccessTokenExpired();
            }
        })
    }

    // const startFlow =()=>{
    //     if(apiData.POINTS.isFetching){
    //         setIsLoading(true);
    //     } else if(!apiData.POINTS.isFetching && !apiData.POINTS.data){
    //         //show error using top popup
    //         props.closeOrderPopUp(true, apiData.POINTS.errorMsg, "", true)
    //         handleGoBack();
    //     } else{
    //         setIsLoading(false);
    //     }
    // }

    useEffect(()=>{

        setCurrentWidgetPrevData(props.currentWidgetObj)
        props.currentWidget({widgetType: true});

        return () => {
            props.currentWidget(currentWidgetPrevData);
        }
    },[])

  
    useEffect(() => {
        const getData = async ()=>{
            setIsLoading(true)
            await getMyPointsData();
            setIsLoading(false);
        }

        if(props.externalSignIn.accessToken) getData()

     }, [props.externalSignIn.accessToken])

    return (
        <>
            {
                !isLoading && !apiData.POINTS.isFetching ? (
                    apiData.POINTS.data &&
                <div class="points-page">
                <div class="content" >
                    <div class="heading">VIRGIN POINTS</div>
                    <div class="points-display">
                        <div>
                            <div class="label"> Available Points</div>
                            <div class="value">{ apiData.POINTS.data && apiData.POINTS.data.pointsInfo.availablePoints }</div>
                        </div>
                        <div>
                            <div class="label">Pending Points</div>
                            <div class="value">{ apiData.POINTS.data && apiData.POINTS.data.pointsInfo.pendingPoints }</div>
                        </div>
                    </div>
                    <div class="activity heading"> Virgin Hotels Activity</div>
                    <div class="functional-widgets" >
                               
                            { apiData.POINTS.data && (
                                 apiData.POINTS.data.activityInfo.length > 0
                                 ?
                                 apiData.POINTS.data.activityInfo.map((item)=>{
                                    return <div class={`tile-selection tile-container`}>
                                            {/* <div class="tile-selection-img">
                                                <img src="http://144.202.36.79:8080/../cmsData/hoteligenceClient/mobileApp/virginPosterImage.jpg"></img>
                                            </div> */}
                                            <div class="tile-selection-text">
                                                <div class="head">
                                                    <div class="tile-selection-heading">{item.description}</div>
                                                    <div class="tile-selection-date">{moment(item.transactionDate).format(props.dateFormat.toUpperCase()) }</div>
                                                </div>
                                                <div class="tile-selection-desc">Points {item.points}</div>
                                            </div>
                                        </div>
                                })
                                 :

                                <div class="no-data">You don't have any activity yet.</div>
                             )
                            
                            
                            
                            }
                       </div>
                </div>
                </div>
                )
                :
                <Loader
                    enableClose={true}
                    showClose={props.showLoaderClose} 
                    close={() => {
                                props.setLoader(false, null, false)
                                props.setLoaderClosed(true)
                            }} 
                    displayMsg={props.loaderMessage} />
            }
           
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        appLauncherWidget: state.store.appLauncher.widget,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        openExternalLinkInSameTab: state.store2.openExternalLinkInSameTab,
        dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
         externalSignIn: state.store2.externalSignIn,
         showLoaderClose: state.store2.showLoaderClose,
         loaderMessage: state.store2.loaderMessage,

    }
}
export default connect(mapStateToProps, { setGoHome, currentWidget, setShowCustomPopup, closeOrderPopUp, sendAnalytics ,setExternalSignIn, setLoader, setLoaderClosed})(
    withTranslation("translations")(PointsPage)
);